<template>
  <section>
    <h2>Error {{ $route.params.code }}</h2>
    <p>Something went wrong. Please try again.</p>
    <router-link to="/">Go Home</router-link>
  </section>
</template>
<script setup lang="ts"></script>
